var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.deleteRemindShow,
          expression: "deleteRemindShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "deleteRemind" } }, [
        _c("div", { staticClass: "title" }, [
          !_vm.payVip
            ? _c("span", [
                _vm.unsubscribeShow
                  ? _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.common.unsubscribe")))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.unsubscribeShow
                  ? _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("language.rightTopBanner.deleteAccount"))
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.payVip
            ? _c("span", [
                _vm._v(_vm._s(_vm.$t("language.common.unsubscribe")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.closePage()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "delete-remind-content" }, [
          !_vm.payVip
            ? _c("span", [
                _vm.unsubscribeShow
                  ? _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "language.popup.personalCenter.pleaseUnsubscribe"
                          )
                        )
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.unsubscribeShow
                  ? _c("div", [
                      _vm._v(
                        _vm._s(
                          _vm.$t("language.popup.personalCenter.deletePremium")
                        )
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.payVip
            ? _c("div", [
                _vm._v(_vm._s(_vm.$t("language.paySystem.deleteSubAccount")))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "delete-remind-footer" }, [
            !_vm.payVip
              ? _c("div", [
                  _vm.unsubscribeShow
                    ? _c("div", { staticClass: "unsubscribe-button" }, [
                        _c(
                          "button",
                          {
                            staticStyle: { "border-radius": "5Px" },
                            on: { click: _vm.switchOldVersion }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "language.popup.personalCenter.switchOld"
                                )
                              )
                            )
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.unsubscribeShow
                    ? _c("div", { staticClass: "delete-button" }, [
                        _c(
                          "button",
                          {
                            staticClass: "delete-remind-one",
                            on: {
                              click: function($event) {
                                return _vm.deleteAccount()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("language.common.delete")))]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "delete-remind-two",
                            on: {
                              click: function($event) {
                                return _vm.closePage()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.payVip
              ? _c("div", { staticClass: "remind-bind-delbutton" }, [
                  _c(
                    "button",
                    {
                      staticClass: "delete-remind-one",
                      on: {
                        click: function($event) {
                          return _vm.unsubAccount()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.unsubscribe")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "delete-remind-two",
                      on: {
                        click: function($event) {
                          return _vm.closePage()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c69f74e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c69f74e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/personal_center_popups/delete_account_remind_popup.vue
// module id = null
// module chunks = 